import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { PaymentCustomer } from './payment-customer';
import { PaymentIdentifier } from './payment-identifier';
import { PaymentProvider } from './payment-provider';
import { Vendor } from './vendor';

export class PaymentIdentifierSetup extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static PaymentIdentifierSetupProperties: (
    | {
        property: keyof PaymentIdentifierSetup;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof PaymentIdentifierSetup;
        type: 'alias';
      }
    | {
        property: keyof PaymentIdentifierSetup;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'PaymentIdentifierId', type: 'column', dataType: 'number' },
    { property: 'PaymentCustomerId', type: 'column', dataType: 'number' },
    { property: 'SetupId', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Vendor', model: 'Vendor', type: 'association' },
    {
      property: 'PaymentIdentifier',
      model: 'PaymentIdentifier',
      type: 'association'
    },
    {
      property: 'PaymentCustomer',
      model: 'PaymentCustomer',
      type: 'association'
    }
  ];

  static {
    PaymentIdentifierSetup.PaymentIdentifierSetupProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          PaymentIdentifierSetup.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          PaymentIdentifierSetup.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          PaymentIdentifierSetup.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(PaymentIdentifierSetupObject: Partial<PaymentIdentifierSetup>) {
    super();

    PaymentIdentifierSetup.PaymentIdentifierSetupProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = PaymentIdentifierSetupObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number | null;
  VendorId?: number;
  PaymentIdentifierId?: number;
  PaymentCustomerId?: number;
  SetupId?: string;
  createdAt?: Date;
  updatedAt?: Date;

  Vendor?: Vendor;
  PaymentIdentifier?: PaymentIdentifier;
  PaymentCustomer?: PaymentCustomer;
}
